import { api } from './api';
import { PublicLandingPageData } from './publicApi';

// Types for landing page settings
export interface LandingPageSettings {
  headline?: string;
  subheadline?: string;
  bio?: string;
  contactEmail?: string;
  phone?: string;
  website?: string;
  linkedIn?: string;
  instagram?: string;
  primaryColor?: string;
  showServices?: boolean;
  showTestimonials?: boolean;
  metaTitle?: string;
  metaDescription?: string;
  isPublished?: boolean;
}

export interface LeadMagnetSettings {
  enabled?: boolean;
  headline?: string;
  subheadline?: string;
  buttonText?: string;
  thankYouMessage?: string;
  aiContext?: string;
}

export interface LeadStats {
  totalLeads: number;
  leadsThisMonth: number;
  lastLeadAt?: string;
}

export interface LandingPageData {
  slug: string;
  landingPage: LandingPageSettings;
  leadMagnet: LeadMagnetSettings;
  leadStats: LeadStats;
  publicUrl: string;
}

export interface LandingPageUpdatePayload {
  landingPage?: Partial<LandingPageSettings>;
  leadMagnet?: Partial<LeadMagnetSettings>;
}

export const landingPageApi = {
  /**
   * Get current user's landing page settings
   */
  getLandingPage: async (): Promise<LandingPageData> => {
    const { data } = await api.get('/landing-page');
    return data.data;
  },

  /**
   * Update landing page settings
   */
  updateLandingPage: async (updates: LandingPageUpdatePayload): Promise<LandingPageData> => {
    const { data } = await api.patch('/landing-page', updates);
    return data.data;
  },

  /**
   * Get preview data (works even if not published)
   * Returns same format as public API for consistent rendering
   */
  getPreview: async (): Promise<PublicLandingPageData> => {
    const { data } = await api.post('/landing-page/preview');
    return data.data;
  },
};
